import { connect } from 'react-redux'

import Visibility from './Visibility'
import makeHasPermission from '../selectors/makeHasPermission'

const stateToProps = () => {
  const hasPermission = makeHasPermission()
  return (state, props) => ({
    isPermitted: hasPermission(state, {
      permissions: props.permissions,
      permissionsWithRegex: props.permissionsWithRegex,
    }),
  })
}

export default connect(stateToProps)(Visibility)
